import getStripeAccount from './get-stripe-account';
import { stripePlatformAccountId, isProduction } from '@dashboard/services/env';

export default function getStripeDashboardUrl(
  path = '',
  { seller, isAdminLoggedInAsSeller, isConnectAccountView } = {},
) {
  const stripeAccount = getStripeAccount(seller);
  const testModePrefix = isProduction ? '' : '/test';

  // Viewing a Connect account from the platform dashboard
  if (isConnectAccountView) {
    return `https://dashboard.stripe.com/${stripePlatformAccountId}${testModePrefix}${path}`;
  }

  // Seller is not connected to Stripe
  if (!stripeAccount) {
    return `https://dashboard.stripe.com${testModePrefix}${path}`;
  }

  // Admin ghosting as seller → Connect view-as URL
  if (isAdminLoggedInAsSeller) {
    return `https://dashboard.stripe.com/${stripePlatformAccountId}/connect/view-as/${stripeAccount}${testModePrefix}${path}`;
  }

  // Regular merchant → prefix with their account ID
  return `https://dashboard.stripe.com/${stripeAccount}${testModePrefix}${path}`;
}
